// apiConfig.js

export const BACKEND_URL = 'https://mern01-server.onrender.com'; // Your Render backend domain
